import { useUsuarioEmpresaActiva, useUsuarioEmpresas } from "api/Usuario.hook"
import Button from "common/components/Button/Button"
import Modal from "common/components/Modal/Modal"
import { ModalValidacion } from "features/User/forms/PerfilEmpresa/ModalValidacion"
import VerificarEmpresaNotification from "features/User/forms/PerfilEmpresa/VerificarEmpresaNotification"
import { MODES_MODAL_VARIFICACION } from "features/User/forms/PerfilEmpresa/VerificarEmpresaNotification/constant"
import { getValidateModalStatusSelector } from "features/User/redux/selectors/userSelectors"
import {
  setHideValidarEmpresaModal,
  setShowValidarEmpresaModal,
  settHideValidarEmpresaErrorModal,
} from "features/User/redux/slices/empresaSlice"
import { validateEmpresa } from "features/User/redux/slices/userSlice"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import CrearEmpresaModal from "../../components/CrearEmpresaModal"
import EmpresaCard from "../../components/EmpresaCard"
import useCambiarEmpresa from "../../hooks/useCambiarEmpresa"

const SeleccionDeEmpresa = () => {
  const { t } = useTranslation()
  const {
    usuarioEmpresas: { items: empresas },
    usuarioEmpresasIsLoading,
  } = useUsuarioEmpresas()
  const {
    activeCompany: { id, nif },
  } = useUsuarioEmpresaActiva()
  const { isCambiandoEmpresaActiva, crearNuevaEmpresa, setEmpresaActiva } =
    useCambiarEmpresa()
  const [isCrearFormVisible, setIsCrearFormVisible] = useState(false)

  const [empresaAvalidar, setEmpresaAvalidar] = useState()

  const dispatch = useDispatch()

  const { showValidarEmpresaModal, showValidarEmpresaErrorModal } = useSelector(
    getValidateModalStatusSelector
  )

  const handleCloseValidateModal = () => {
    dispatch(setHideValidarEmpresaModal())
  }

  const handleCloseValidateModalError = () => {
    dispatch(settHideValidarEmpresaErrorModal())
  }

  const handleShowValidateModal = (e: $TSMigrationFixMe) => {
    e.preventDefault()
    dispatch(setShowValidarEmpresaModal())
  }

  const onHandleSubmit = () => {
    dispatch(
      // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
      validateEmpresa({
        // @ts-expect-error TS(2339): Property 'cif' does not exist on type 'never'.
        cif: empresaAvalidar?.cif,
        // @ts-expect-error TS(2339): Property 'razonSocial' does not exist on type 'nev...
        razonSocial: empresaAvalidar?.razonSocial,
      })
    )
    handleCloseValidateModal()
  }

  const handleEmpresaAvalidar = (
    e: $TSMigrationFixMe,
    empresa: $TSMigrationFixMe
  ) => {
    setEmpresaAvalidar(empresa)
    handleShowValidateModal(e)
  }

  return (
    <div>
      <div className='tw-w-full tw-px-4 tw-mx-auto tw-max-w-[720px] lg:tw-max-w-[992px] xl:tw-max-w-[1320px]'>
        <div className='tw-flex tw-items-center tw-justify-between tw-mt-12'>
          <span className='tw-text-left tw-text-primary tw-font-medium tw-text-xl'>
            {t("seleccionDeEmpresa.title")}
          </span>

          <Button
            className='!tw-bg-primary'
            onClick={() => setIsCrearFormVisible(true)}
          >
            {t("seleccionDeEmpresa.addCompany")}
          </Button>
        </div>

        <div className='tw-pt-[30px] tw-grid tw-grid-rows-auto tw-grid-col-1 lg:tw-grid-cols-2 xl:tw-grid-cols-3 tw-gap-3 tw-place-items-center'>
          {!usuarioEmpresasIsLoading &&
            empresas?.map((empresa) => (
              <EmpresaCard
                key={empresa.id}
                empresa={empresa}
                empresaActivaId={id}
                isCambiandoEmpresaActiva={isCambiandoEmpresaActiva}
                handleCambiarEmpresaActiva={setEmpresaActiva}
                handleEmpresaAvalidar={handleEmpresaAvalidar}
              />
            ))}
        </div>
      </div>

      <CrearEmpresaModal
        visible={isCrearFormVisible || (!usuarioEmpresasIsLoading && !nif)}
        crearNuevaEmpresa={crearNuevaEmpresa}
        onHide={() => setIsCrearFormVisible(false)}
      />
      <Modal
        onHide={handleCloseValidateModal}
        visible={showValidarEmpresaModal}
        className='!tw-w-[512px] tw-rounded-lg'
        closable={false}
        showHeader={false}
        breakpoints={false}
        contentClassName='!tw-p-0 !tw-rounded-lg'
      >
        <VerificarEmpresaNotification
          // @ts-expect-error TS(2339): Property 'razonSocial' does not exist on type 'nev...
          empresaActivaRazonSocial={empresaAvalidar?.razonSocial}
          onHide={handleCloseValidateModal}
          onSubmit={onHandleSubmit}
          mode={MODES_MODAL_VARIFICACION.VALIDAR}
        />
      </Modal>
      <Modal
        onHide={handleCloseValidateModalError}
        visible={showValidarEmpresaErrorModal.show}
        className='!tw-w-[448px] tw-rounded-lg'
        closable={false}
        showHeader={false}
        breakpoints={false}
        contentClassName='!tw-p-0 !tw-rounded-lg'
      >
        <VerificarEmpresaNotification
          // @ts-expect-error TS(2339): Property 'razonSocial' does not exist on type 'nev...
          empresaActivaRazonSocial={empresaAvalidar?.razonSocial}
          errorInfo={showValidarEmpresaErrorModal.info}
          onHide={handleCloseValidateModalError}
          onSubmit={handleCloseValidateModalError}
          mode={MODES_MODAL_VARIFICACION.ERROR}
        />
      </Modal>

      <ModalValidacion />
    </div>
  )
}

export default SeleccionDeEmpresa
